/*
 * @Author       : dengjianjun
 * @Date         : 2021-12-06 17:37:05
 * @LastEditors  : dengjianjun
 * @LastEditTime : 2021-12-06 18:09:21
 * @Description  : 
 * @FilePath     : /fe-estrain-customer/src/mixins/index.js
 */
const app = getApp()

export default {
  onLoad() {

    if (__mpx_mode__ === 'web') {
      document.documentElement.addEventListener(
        "touchstart",
        function(event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        },
        false
      );

      let lastTouchEnd = 0;
      document.documentElement.addEventListener(
        "touchend",
        function(event) {
          let now = Date.now();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );

      document.addEventListener("gesturestart", function(event) {
        event.preventDefault();
      });
    }

    if (app.globalData?.hasLogin) {
      this?.init?.()
    } else {
      //如果没有，给app定义一个回调，拿到接口返回参数
      app.globalData.initCallback = data => {
        this?.init?.()
      }
    }
  }
}
